import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const OrganIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="52px" height="52px" viewBox="0 0 52 52" version="1.1" {...rest}>
      <g
        id="Symbols-Stomach"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Stomach" stroke={color} strokeWidth="3">
          <g id="Group" transform="translate(1.729000, 1.729000)">
            <path d="M8.41947826,48.412 L8.41947826,45.2546957 C8.4220536,43.7756166 9.20449599,42.4075425 10.4780407,41.6553687 C14.5250646,45.3270104 19.7940634,47.3604748 25.2584348,47.3595652 C37.4666783,47.3595652 48.412,37.4666783 48.412,25.2584348 C48.412,19.8152421 48.412,4.20973913 27.3633043,4.20973913 C25.0383296,4.20973913 23.1535652,2.32497472 23.1535652,0" />
            <path d="M14.734087,0 L14.734087,2.10486957 C14.734087,6.75481901 18.5036158,10.5243478 23.1535652,10.5243478 L25.1637157,10.5243478 C27.3906677,34.0357409 0,30.6574252 0,43.1498261 L0,48.412" />
            <line x1="25.1658205" y1="10.5243478" x2="27.3633043" y2="10.5243478" />
          </g>
        </g>
      </g>
    </svg>
  );
};
